import { TransferProduct } from '@/api/Cart/cart.interfaces';
import { Money } from '@libs/money/money.interfaces';

export const mapTransferLabel = (product: TransferProduct): string => {
    return product.Description;
};

export const mapTransferSubLabel = (product: TransferProduct): string | undefined => {
    return product?.Vehicle?.TransferCategory;
};

export const mapTransferPrice = (product: TransferProduct): Money => {
    return {
        Amount: product.Price.Amount,
        Currency: product.Price.Currency,
    };
};
